// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"styles_fieldset__1jjNW","label":"styles_label__I5AOC","disabled":"styles_disabled__1Bwjb","largetext":"styles_largetext__1Nxxy"};